import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Pencil, Trash2, Plus, Mail } from "lucide-react";
import axios from "axios";
import { API_BASE_URL } from "../../../../config/config";
import { OrbitProgress } from "react-loading-indicators";

const API_URL = `${API_BASE_URL}/users`;

export default function Dh_Utilisateurs() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API_URL, { withCredentials: true });
      setData(res.data);
    } catch (error) {
      console.error("Erreur récupération :", error);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  const filtered = data.filter(user =>
    user.name.toLowerCase().includes(search.toLowerCase())
  );

  const openModal = (user = null) => {
    setSelectedItem(user);
    if (user) {
      Object.keys(user).forEach(key => {
        if (key in user) setValue(key, user[key]);
      });
    } else {
      reset();
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    reset();
    setSelectedItem(null);
  };

  const onSubmit = async (formData) => {
    try {
      if (selectedItem) {
        await axios.patch(API_URL, { ...formData, id: selectedItem.id }, { withCredentials: true });
      } else {
        await axios.post(API_URL, formData, { withCredentials: true });
      }
      fetchData();
      closeModal();
    } catch (error) {
      console.error("Erreur de soumission :", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(API_URL, {
        data: { id },
        withCredentials: true,
      });
      fetchData();
    } catch (error) {
      console.error("Erreur de suppression :", error);
    }
  };

  return (
    <div className="p-6 text-white min-h-screen">
      <div className="max-w-7xl rounded-lg -mt-5 dark:bg-gray-800 bg-gray-200 mx-auto p-10">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">Utilisateurs</h2>
          {/* <button
            onClick={() => openModal()}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-500 rounded text-sm font-medium"
          >
            <Plus size={18} /> Ajouter un utilisateur
          </button> */}
        </div>

        <div className="flex justify-end mb-4">
          <input
            type="text"
            placeholder="Search..."
            className="px-3 py-2 bg-gray-800 border border-gray-600 rounded text-sm w-64"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {loading ? (
          <div className="text-center py-8 text-gray-400"><OrbitProgress variant="track-disc" color="#125f69ff" size="small" text="" textColor="#484e51ff" /></div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm">
                <thead className="bg-[#1a253c] text-gray-400 text-left">
                  <tr>
                    <th className="px-4  py-2">
                      
                      Nom
                    </th>
                    <th className="px-4  py-2">
                      Postnom
                    </th>
                    <th className="px-4  py-2">
                      Prénom
                    </th>
                    <th className="px-4  py-2">
                      Téléphone
                    </th>
                    <th className="px-4 flex items-center gap-1 py-2">
                       
                      Email
                    </th>
                    <th className="px-4  py-2">
                      Naissance
                    </th>
                    <th className="px-4 py-2 text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((user) => (
                    <tr key={user.id} className="border-t border-gray-700">
                      <td className="px-4  py-2 font-semibold">
                        <div className="flex items-center gap-2">
                          <svg className="w-2 h-2 text-gray-800 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12.4472 2.10557c-.2815-.14076-.6129-.14076-.8944 0L5.90482 4.92956l.37762.11119c.01131.00333.02257.00687.03376.0106L12 6.94594l5.6808-1.89361.3927-.13363-5.6263-2.81313ZM5 10V6.74803l.70053.20628L7 7.38747V10c0 .5523-.44772 1-1 1s-1-.4477-1-1Zm3-1c0-.42413.06601-.83285.18832-1.21643l3.49538 1.16514c.2053.06842.4272.06842.6325 0l3.4955-1.16514C15.934 8.16715 16 8.57587 16 9c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4Z" />
                            <path d="M14.2996 13.2767c.2332-.2289.5636-.3294.8847-.2692C17.379 13.4191 19 15.4884 19 17.6488v2.1525c0 1.2289-1.0315 2.1428-2.2 2.1428H7.2c-1.16849 0-2.2-.9139-2.2-2.1428v-2.1525c0-2.1409 1.59079-4.1893 3.75163-4.6288.32214-.0655.65589.0315.89274.2595l2.34883 2.2606 2.3064-2.2634Z" />
                          </svg>
                        {user.name}
                        </div>
                      </td>
                      <td className="px-4  py-2 font-semibold">{user.subname}</td>
                      <td className="px-4  py-2 font-semibold">{user.surname}</td>
                      <td className="px-4  py-2 font-semibold">
                        <div className="flex gap-2 items-center">
                          <svg className="w-7 h-7 text-gray-800 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.427 14.768 17.2 13.542a1.733 1.733 0 0 0-2.45 0l-.613.613a1.732 1.732 0 0 1-2.45 0l-1.838-1.84a1.735 1.735 0 0 1 0-2.452l.612-.613a1.735 1.735 0 0 0 0-2.452L9.237 5.572a1.6 1.6 0 0 0-2.45 0c-3.223 3.2-1.702 6.896 1.519 10.117 3.22 3.221 6.914 4.745 10.12 1.535a1.601 1.601 0 0 0 0-2.456Z" />
                          </svg>


                        {user.phone ? (user.phone) :(<> ---- ---- ---- </>) }
                        </div>
                      </td>
                      <td className="px-4  py-2 font-semibold">
                        <div className="flex items-center gap-3">
                          <Mail className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                        {user.email}
                        </div>
                      </td>
                      <td className="px-4  py-2 font-semibold">{user.birthday}</td>
                      <td className="px-4  py-2 text-right flex justify-end gap-2">
                        <button onClick={() => openModal(user)} className="text-blue-400 hover:text-blue-600">
                          <Pencil size={16} />
                        </button>
                        <button onClick={() => handleDelete(user.id)} className="text-red-400 hover:text-red-600">
                          <Trash2 size={16} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-xs text-gray-400 mt-4">
              Affichage de {filtered.length} sur {data.length} utilisateurs
            </p>
          </>
        )}
      </div>

      {modalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-[#121c31] rounded-lg p-6 w-[90%] max-w-md">
            <h2 className="text-xl font-bold mb-4">
              {selectedItem ? "Modifier l'utilisateur" : "Ajouter un utilisateur"}
            </h2>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <input
                {...register("name", { required: true })}
                placeholder="Nom"
                className="w-full p-2 rounded bg-gray-700 text-white"
              />
              <input
                {...register("subname", { required: true })}
                placeholder="Postnom"
                className="w-full p-2 rounded bg-gray-700 text-white"
              />
              <input
                {...register("surname", { required: true })}
                placeholder="Prénom"
                className="w-full p-2 rounded bg-gray-700 text-white"
              />
              <input
                {...register("phone", { required: true })}
                placeholder="Téléphone"
                className="w-full p-2 rounded bg-gray-700 text-white"
              />
              <input
                {...register("email", { required: true })}
                placeholder="Email"
                type="email"
                className="w-full p-2 rounded bg-gray-700 text-white"
              />
              <input
                {...register("birthday", { required: true })}
                placeholder="Date de naissance"
                type="date"
                className="w-full p-2 rounded bg-gray-700 text-white"
              />
              {!selectedItem && (
                <input
                  {...register("password", { required: true })}
                  placeholder="Mot de passe"
                  type="password"
                  className="w-full p-2 rounded bg-gray-700 text-white"
                />
              )}

              <div className="flex justify-between gap-4">
                <button type="submit" className="w-full py-2 bg-blue-600 hover:bg-blue-500 rounded text-white">
                  {selectedItem ? "Modifier" : "Ajouter"}
                </button>
                <button
                  type="button"
                  onClick={closeModal}
                  className="w-full py-2 bg-gray-600 hover:bg-gray-500 rounded text-white"
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
